/*
 * @Author: Cookie
 * @Date: 2020-07-13 13:50:35
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-03 17:27:46
 * @Description:
 */
import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';
import { pxToVW } from '@/utils/pxToVW';
import {eventMap} from '@/utils/constant';
import { track } from '@/wrappers';

@track
class Text extends Component {
  componentDidMount=()=>{
    const {openQuickApp} = CrgtEvent.parseUrlQuery(window.location.href);
    const isOpenQuickApp = !!openQuickApp;
    const {event} = this.props;
    if(isOpenQuickApp && event === 'openQuickApp') {
      this.onClick()
    }
  }
  onClick = (...args) => {
    const { event = 'doNothing', handleChangePage, router, onClick } = this.props;
    onClick && onClick(...args);
    let params = {};
    params = eventMap(this.props);
    console.log('event',event)
    const clickEvent = !_.isEmpty(event) ?
      (event !== 'navLink' ? function () { CrgtEvent[`${event}`](params) } : () => { handleChangePage && handleChangePage(router) })
      : null;
    clickEvent()

  }
  getClass = (size) => {
    let textClass = 'default-text';
    switch (size) {
      case 'huge':
        return textClass = 'huge-text';
      case 'big':
        return textClass = 'big-text';
      case 'large':
       return textClass = 'large-text';
      case 'small':
        return textClass = 'small-text';
      default: return textClass;
    }

  }

  renderText = (text) => {
    if (!_.isEmpty(text)) {
      const desc = text.split('+&+');
      return desc.map((item, index) => {
        if (_.isEmpty(item)) {
          return (<></>)
        }
        return (<p key={index}>{item}</p>)
      })
    }
    return text;
  }

  render() {
    const { text, size = 'default', textAlign, fontSize, fontWeight, lineHeight, style } = this.props;
    const newFontSize = fontSize && pxToVW({ fontSize });
    let textStyle = _.omitBy(Object.assign({}, { textAlign, fontWeight, lineHeight }, newFontSize, style), _.isUndefined);
    const textClass = this.getClass(size);
    return (<div className={textClass} style={textStyle} onClick={this.onClick}>{
      this.renderText(text)
    }</div>)
  }
}

export default Text;
